import { FileHandlePlugin, FileHandler, type FileHandlerOptions } from "@tiptap/extension-file-handler"
import { PluginKey } from "@tiptap/pm/state"

import { sdk } from "../../../sdk"
import { IssueAttachmentNode } from "../../nodes"

interface IssueFileHandlerOptions extends Pick<FileHandlerOptions, "allowedMimeTypes"> {
	uuid: string
}

export const IssueFileHandler = FileHandler.extend<IssueFileHandlerOptions>({
	name: "IssueFileHandler",
	addProseMirrorPlugins() {
		return [
			FileHandlePlugin({
				key: new PluginKey(this.name),
				editor: this.editor,
				allowedMimeTypes: this.options.allowedMimeTypes,
				onDrop: async (editor, files, pos) => {
					const [offlineAttachments, _promise] = await sdk.issueAttachments.bulkAdd(
						files.map((file) => ({
							issue: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContentAt(
							pos,
							offlineAttachments.map((offlineAttachment) => ({
								type: IssueAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
				onPaste: async (editor, files, _htmlContent) => {
					const [offlineAttachments, _promise] = await sdk.issueAttachments.bulkAdd(
						files.map((file) => ({
							issue: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContent(
							offlineAttachments.map((offlineAttachment) => ({
								type: IssueAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
			}),
		]
	},
})
